class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    
    // DOM Elements
    this.hoursEl = this.querySelector('[data-hours]');
    this.minutesEl = this.querySelector('[data-minutes]');
    this.secondsEl = this.querySelector('[data-seconds]');

    this.updateTimer();
    this.timerInterval = setInterval(this.updateTimer.bind(this), 1000);
  }

  updateTimer() {
    const now = new Date();
    
    // Set target to exactly 1 second before midnight of the current day
    const targetDate = new Date(
      now.getFullYear(), 
      now.getMonth(), 
      now.getDate(), 
      23, 59, 59
    ).getTime();

    const currentTime = now.getTime();
    const distance = targetDate - currentTime;

    // Failsafe in case interval fires exactly on the millisecond of midnight
    if (distance < 0) {
      this.hoursEl.innerText = "00";
      this.minutesEl.innerText = "00";
      this.secondsEl.innerText = "00";
      return;
    }

    // Calculate time left in the current 24-hour cycle
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Output to DOM, forcing double digits (e.g., "09" instead of "9")
    this.hoursEl.innerText = hours.toString().padStart(2, '0');
    this.minutesEl.innerText = minutes.toString().padStart(2, '0');
    this.secondsEl.innerText = seconds.toString().padStart(2, '0');
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}